import "./index.css";
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Typography } from '@design-system/typography';
import { Modal as Modal$1 } from '@phx-husky/modal';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Button } from '@design-system/button';
var ModalHeader = function ModalHeader(_ref) {
  var topElements = _ref.topElements,
    closeAriaLabel = _ref.closeAriaLabel,
    closeModal = _ref.closeModal,
    closeIconSize = _ref.closeIconSize,
    title = _ref.title;
  return jsxs(Fragment, {
    children: [topElements ? jsxs("div", Object.assign({
      className: "cds-modal-window__top-elements"
    }, {
      children: [topElements, jsx("div", Object.assign({
        className: "cds-modal-window__close-button-container"
      }, {
        children: jsx(Button, Object.assign({
          className: "cds-modal-window__close-button",
          "aria-label": closeAriaLabel,
          onClick: closeModal,
          variant: "subtle-icon",
          iconPrefix: {
            props: {
              icon: 'close'
            }
          },
          size: closeIconSize,
          autoFocus: true
        }, {
          children: closeAriaLabel !== null && closeAriaLabel !== void 0 ? closeAriaLabel : ''
        }))
      }))]
    })) : jsx("div", Object.assign({
      className: "cds-modal-window__close-button-container"
    }, {
      children: jsx(Button, Object.assign({
        className: "cds-modal-window__close-button",
        "aria-label": closeAriaLabel,
        onClick: closeModal,
        variant: "subtle-icon",
        iconPrefix: {
          props: {
            icon: 'close'
          }
        },
        size: closeIconSize,
        autoFocus: true
      }, {
        children: closeAriaLabel !== null && closeAriaLabel !== void 0 ? closeAriaLabel : ''
      }))
    })), title && jsx(Typography, {
      className: "cds-modal-window__title",
      tag: "h3",
      variant: "body",
      size: "xl",
      content: title,
      align: "center"
    })]
  });
};
var Modal = forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    children = _ref2.children,
    isShowing = _ref2.isShowing,
    close = _ref2.close,
    closeModal = _ref2.closeModal,
    disableOnClickClose = _ref2.disableOnClickClose,
    title = _ref2.title,
    closeAriaLabel = _ref2.closeAriaLabel,
    topElements = _ref2.topElements,
    _ref2$closeIconSize = _ref2.closeIconSize,
    closeIconSize = _ref2$closeIconSize === void 0 ? 'small' : _ref2$closeIconSize,
    _ref2$fullPage = _ref2.fullPage,
    fullPage = _ref2$fullPage === void 0 ? false : _ref2$fullPage,
    _ref2$showHeader = _ref2.showHeader,
    showHeader = _ref2$showHeader === void 0 ? true : _ref2$showHeader;
  return jsx("div", Object.assign({
    ref: ref,
    className: classNames('cds-modal', className, {
      'cds-modal--full-page': fullPage
    })
  }, {
    children: jsxs(Modal$1, Object.assign({
      isShowing: isShowing,
      close: close,
      disableOnClickClose: disableOnClickClose,
      className: classNames('cds-modal-window', className, {
        'cds-modal-window--full-page': fullPage
      }),
      ariaLabel: title
    }, {
      children: [showHeader ? jsx(ModalHeader, Object.assign({}, {
        topElements: topElements,
        closeAriaLabel: closeAriaLabel,
        closeModal: closeModal,
        closeIconSize: closeIconSize,
        title: title
      })) : null, title ? jsx(Typography, {
        className: "cds-modal-window__title",
        tag: "h3",
        variant: "body",
        size: "xl",
        content: title,
        align: "center"
      }) : null, jsx("div", Object.assign({
        className: "cds-modal-window__content"
      }, {
        children: children
      }))]
    }))
  }));
});
export { Modal };